<script>
  import { router } from '@inertiajs/svelte'

  let { category = {}, children = [], boards = [], posts_count = 0, flash = {} } = $props()

  function handleDelete() {
    if (confirm(`"${category.name}" 카테고리를 삭제하시겠습니까?`)) {
      router.delete(`/admin/categories/${category.id}`)
    }
  }
</script>

<!-- Breadcrumb -->
  <div class="flex items-center gap-2 text-caption text-content-tertiary mb-6">
    <a href="/admin" class="hover:text-primary transition-colors">관리자</a>
    <span>/</span>
    <a href="/admin/categories" class="hover:text-primary transition-colors">카테고리</a>
    <span>/</span>
    <span class="text-content">{category.name}</span>
  </div>

  {#if flash.alert}
    <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error-dark dark:text-error text-body2">
      {flash.alert}
    </div>
  {/if}

  <main class="space-y-6">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        {#if category.color}
          <span class="w-6 h-6 rounded-full" style="background-color: {category.color}"></span>
        {/if}
        <div>
          <h2 class="text-h1 text-content">{category.name}</h2>
          <p class="text-body2 text-content-tertiary mt-1">/{category.slug}</p>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <a href={`/admin/categories/${category.id}/edit`} class="btn btn-secondary btn-md">수정</a>
        <button onclick={handleDelete} class="btn btn-error btn-md">삭제</button>
      </div>
    </div>

    <!-- Category Details -->
    <div class="card card-bordered p-6 shadow-md">
      <h3 class="text-title text-content mb-4">카테고리 정보</h3>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <div class="text-caption text-content-tertiary">상위 카테고리</div>
          <div class="text-body1 font-medium text-content mt-1">
            {#if category.parent}
              <a href={`/admin/categories/${category.parent.id}`} class="text-primary hover:text-primary-dark">{category.parent.name}</a>
            {:else}
              <span class="text-content-tertiary">없음 (루트)</span>
            {/if}
          </div>
        </div>
        <div>
          <div class="text-caption text-content-tertiary">게시글 수</div>
          <div class="text-body1 font-medium text-content mt-1">{posts_count}</div>
        </div>
        <div>
          <div class="text-caption text-content-tertiary">하위 카테고리</div>
          <div class="text-body1 font-medium text-content mt-1">{category.children_count}</div>
        </div>
        <div>
          <div class="text-caption text-content-tertiary">색상</div>
          <div class="flex items-center gap-2 mt-1">
            {#if category.color}
              <span class="w-5 h-5 rounded-full border border-default" style="background-color: {category.color}"></span>
              <span class="text-body2 text-content-secondary font-mono">{category.color}</span>
            {:else}
              <span class="text-body2 text-content-tertiary">없음</span>
            {/if}
          </div>
        </div>
      </div>
      {#if category.description}
        <div class="mt-4 pt-4 border-t border-default">
          <div class="text-caption text-content-tertiary mb-1">설명</div>
          <p class="text-body1 text-gray-700 dark:text-dark-text-medium">{category.description}</p>
        </div>
      {/if}
      <div class="mt-4 pt-4 border-t border-default text-caption text-content-tertiary">
        생성: {new Date(category.created_at).toLocaleDateString('ko-KR')} | 수정: {new Date(category.updated_at).toLocaleDateString('ko-KR')}
      </div>
    </div>

    <!-- Connected Boards -->
    <div class="card card-bordered p-6 shadow-md">
      <h3 class="text-title text-content mb-4">연결된 게시판 ({boards.length})</h3>
      {#if boards.length > 0}
        <div class="flex flex-wrap gap-2">
          {#each boards as board}
            <a href={`/admin/boards/${board.id}`} class="inline-flex items-center gap-2 px-3 py-1.5 bg-surface-tertiary rounded-lg hover:bg-gray-200 dark:hover:bg-dark-border transition-colors">
              <span class="text-body2 text-gray-700 dark:text-dark-text-medium">{board.name}</span>
            </a>
          {/each}
        </div>
      {:else}
        <p class="text-body2 text-content-tertiary">연결된 게시판이 없습니다</p>
      {/if}
    </div>

    <!-- Children Categories -->
    {#if children.length > 0}
      <div class="card card-bordered p-6 shadow-md">
        <h3 class="text-title text-content mb-4">하위 카테고리 ({children.length})</h3>
        <div class="space-y-2">
          {#each children as child}
            <a href={`/admin/categories/${child.id}`} class="flex items-center justify-between p-3 bg-surface-tertiary rounded-lg hover:bg-gray-100 dark:hover:bg-dark-border transition-colors">
              <div class="flex items-center gap-3">
                {#if child.color}
                  <span class="w-3 h-3 rounded-full" style="background-color: {child.color}"></span>
                {/if}
                <span class="text-body1 text-gray-700 dark:text-dark-text-medium">{child.name}</span>
              </div>
              <span class="text-caption text-content-tertiary">게시글 {child.posts_count}개</span>
            </a>
          {/each}
        </div>
      </div>
    {/if}
  </main>
